import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-[#fdfbf7]" data-id="element-217">
      <div className="container mx-auto px-4" data-id="element-218">
        <div className="text-center mb-16" data-id="element-219">
          <h2 className="md:text-5xl font-extrabold text-[#1a3622] mb-4 text-[28px]" data-id="element-220">
            💳 ELEGÍ TU PACK
          </h2>
          <p className="text-[#5c4033] text-[16px]" data-id="element-221">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-222">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-2xl border border-[#e2e8f0] flex flex-col h-full relative z-10" data-id="element-223">
            <div className="mb-6" data-id="element-224">
              <p className="text-[#8b5a2b] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-225">
                OPCIÓN 1
              </p>
              <h3 className="font-bold text-[#1a3622] mb-2 flex items-center gap-2 text-[20px]" data-id="element-226">
                🏆 MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360
              </h3>
            </div>

            <div className="mb-6 pb-6 border-b border-[#e2e8f0]" data-id="element-227"></div>

            <div className="mb-8" data-id="element-228">
              <div className="flex items-end gap-2" data-id="element-229">
                <span className="text-5xl font-black text-[#1a3622]" data-id="element-230">
                  $19.990
                </span>
                <span className="text-xl font-bold text-[#5c4033] mb-1" data-id="element-231">
                  ARS
                </span>
              </div>
              <p className="text-[#8b5a2b] line-through mt-1" data-id="element-232">$45.000 ARS</p>
            </div>

            <a href="https://www.centralpack.shop/cart/53830980960574:1" target="_blank" rel="noopener noreferrer" className="block mt-auto" data-id="element-233">
              <Button variant="primary" size="lg" fullWidth data-id="element-234">
                🟡 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#1a3622] rounded-3xl p-8 shadow-2xl border-2 border-[#d4af37] flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-235">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#d4af37] text-[#1a3622] font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-236">
              <Zap className="w-4 h-4 fill-[#1a3622]" data-id="element-237" /> ⭐ MÁS ELEGIDO · MEJOR
              VALOR
            </div>

            <div className="mb-6 mt-2" data-id="element-238">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-239">
                🌟 MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360 + HUERTA Y
                PRODUCCIÓN VEGETAL
              </h3>
            </div>

            <div className="mb-6 pb-6 border-b border-[#2c4c3b]" data-id="element-240"></div>

            <div className="mb-8" data-id="element-241">
              <div className="flex items-end gap-2" data-id="element-242">
                <span className="text-5xl font-black text-white" data-id="element-243">$27.990</span>
                <span className="text-xl font-bold text-[#d4af37] mb-1" data-id="element-244">
                  ARS
                </span>
              </div>
              <p className="text-[#cbd5e1] line-through mt-1" data-id="element-245">$75.000 ARS</p>
            </div>

            <a href="https://www.centralpack.shop/cart/53830981026110:1" target="_blank" rel="noopener noreferrer" className="block mt-auto" data-id="element-246">
              <Button variant="primary" size="lg" fullWidth data-id="element-247">
                🟡 LLEVAR PACK COMPLETO
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-[#5c4033] text-sm mb-20" data-id="element-248">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>
      </div>
    </section>;
}